// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cQ2P","content":"styles_content__2DBJZ","tableWrap":"styles_tableWrap__1NKwv"};